"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArchitectureTypes;
(function (ArchitectureTypes) {
    ArchitectureTypes["x64"] = "x64";
    ArchitectureTypes["Other"] = "";
})(ArchitectureTypes = exports.ArchitectureTypes || (exports.ArchitectureTypes = {}));
var OperatingSystems;
(function (OperatingSystems) {
    OperatingSystems["WinPhone"] = "Windows Phone";
    OperatingSystems["WinRT"] = "Windows RT";
    OperatingSystems["Win"] = "Windows";
    OperatingSystems["iOS"] = "iOS";
    OperatingSystems["MacOS"] = "Mac OS X";
    OperatingSystems["Android"] = "Android";
    OperatingSystems["ChromeOS"] = "ChromeOS";
    OperatingSystems["Linux"] = "Linux";
    OperatingSystems["Unknown"] = "Unknown";
})(OperatingSystems = exports.OperatingSystems || (exports.OperatingSystems = {}));
// Yet another OS format name. Currently used for telemetry and download pages
var CanonicalOperatingSystems;
(function (CanonicalOperatingSystems) {
    CanonicalOperatingSystems["Win"] = "windows";
    CanonicalOperatingSystems["Mac"] = "osx";
    CanonicalOperatingSystems["Linux"] = "linux";
    CanonicalOperatingSystems["Other"] = "other";
})(CanonicalOperatingSystems = exports.CanonicalOperatingSystems || (exports.CanonicalOperatingSystems = {}));
// IMPORTANT: the order these items are defined in matters!
var Browsers;
(function (Browsers) {
    Browsers["Opera"] = "(OPR/|Opera)";
    Browsers["Edge"] = "Edge";
    Browsers["MSIE"] = "(Trident|(MSIE \\d+))";
    Browsers["Chrome"] = "Chrome";
    Browsers["Firefox"] = "Firefox";
    Browsers["Safari"] = "Safari";
    Browsers["Unknown"] = "Unknown";
})(Browsers = exports.Browsers || (exports.Browsers = {}));
var DeviceTypes;
(function (DeviceTypes) {
    DeviceTypes["Desktop"] = "Desktop";
    DeviceTypes["Mobile"] = "Mobile";
    DeviceTypes["Tablet"] = "Tablet";
})(DeviceTypes = exports.DeviceTypes || (exports.DeviceTypes = {}));
var DeploymentTypes;
(function (DeploymentTypes) {
    DeploymentTypes["Production"] = "production";
    DeploymentTypes["Devspaces"] = "devspaces";
    DeploymentTypes["Life"] = "life";
    DeploymentTypes["Other"] = "other";
})(DeploymentTypes = exports.DeploymentTypes || (exports.DeploymentTypes = {}));
